import React from 'react';
import { Text, Link as FLink } from '@fluentui/react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.scss';
import useStore, { IStore } from 'app/store';
import { userPaths } from 'app/utils/authUtilities';
import { Trans } from 'react-i18next';
import { StringConstants } from 'app/utils/constants';
import { CATEGORIES, CategoryCardConfig } from 'app/modules/user/requestHelp/CategoryCards';
import { newCreationIntent } from 'app/modules/user/createTicket/creationDraftIdentity';

const QUICK_LINK_PRESENTATION: Record<string, { id: string; label: string }> = {
    sales: { id: 'sales', label: 'Sales question' },
    css: { id: 'support', label: 'Support escalation' },
    warranty: { id: 'warranty', label: 'Warranty need' },
    feature: { id: 'feature', label: 'Feature request' },
    cpe: { id: 'messaging', label: 'Messaging request' },
};

const Footer: React.FC = () => {
    const { pathname } = useLocation();
    const setQuickLinksValue = useStore((state: IStore) => state.setQuickLinksValue);
    const setRedirectRequestType = useStore((state: IStore) => state.setRedirectRequestType);
    const setRedirectCategoryTitle = useStore((state: IStore) => state.setRedirectCategoryTitle);
    const setQuickLinksFLow = useStore((state: IStore) => state.setQuickLinksFLow);
    const setQuickLinksID = useStore((state: IStore) => state.setQuickLinksID);
    const setOriginalRoutingML = useStore((state: IStore) => state.setOriginalRoutingML);

    const setSelectedTab = useStore((state: IStore) => state.setSelectedTab);

    const selectCategory = (category: CategoryCardConfig) => {
        setQuickLinksValue(null);
        setRedirectRequestType(category.requestType);
        setRedirectCategoryTitle(category.pageTitle || category.title);
        setQuickLinksFLow(category.flowId);
        setQuickLinksID(category.linkId);
        setOriginalRoutingML(false);
    };

    if (userPaths.includes(pathname.split('/')[1])) {
        return (
            <>
                <div className="footer">
                    <div className="container">
                        <div className="top-footer">
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="row-flex">
                                        <div className="col-flex left-footer-cont">
                                            <div className="">
                                                <Text>
                                                    <h5>
                                                        <Trans>Help With A</Trans>
                                                    </h5>
                                                </Text>
                                                <ul className="footer_links row-flex ">
                                                    {CATEGORIES.map((category) => {
                                                        const { id, label } = QUICK_LINK_PRESENTATION[category.key];
                                                        return (
                                                            <li key={category.key}>
                                                                <Text>
                                                                    <Link
                                                                        onClick={(event) => {
                                                                            if (event.button === 0 && !event.ctrlKey && !event.metaKey
                                                                                && !event.shiftKey && !event.altKey
                                                                                && !pathname.startsWith('/create-ticket')) selectCategory(category);
                                                                        }}
                                                                        to={newCreationIntent(category.flowId)}
                                                                        data-testid={`${id}-link`}>
                                                                        <span className={`request-icon ${id}-icon`}></span>
                                                                        <Trans>{label}</Trans>
                                                                    </Link>
                                                                </Text>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="ms-Grid-col  ms-md12 ms-lg2">
                                            <div className="links-container-user">
                                                <div>
                                                    <Link role="link" to="/submit-feedback" data-testid="feedback-link">
                                                        <Trans>Feedback</Trans>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-footer">
                        <div className="container">
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm6">
                                        <span className="icon-global"></span> English (United States)
                                        <Text className="links">
                                            <FLink role="link" href="https://www.microsoft.com/en-us/privacy/data-privacy-notice" target="_blank" rel="noopener noreferrer">
                                                Data Protection Notice
                                            </FLink>
                                        </Text>
                                        <Text className="links">
                                            <FLink
                                                role="link"
                                                href="https://www.microsoft.com/en-us/legal/terms-of-use"
                                                target="_blank">
                                                Terms of use
                                            </FLink>
                                        </Text>
                                        <Text className="links">
                                            <FLink
                                                role="link"
                                                href="https://microsoft.sharepoint.com/sites/surface/SitePages/Warranty-&-Support.aspx?xsdata=MDN8MDF8fGQ5NzY4MTVkZmRhNDQ5MWZhYTEwOTM5YjRjMWVmZjc1fDcyZjk4OGJmODZmMTQxYWY5MWFiMmQ3Y2QwMTFkYjQ3fDF8MHw2Mzc3MjU4OTY2MTY0MDc5Mzh8R29vZHxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaUlpd2lRVTRpT2lJaUxDSlhWQ0k2TVRKOQ%3D%3D&sdata=dFI3RTA0N25LR0F6RkwwNnpoOGEyUk9USWtDblAyZmlyVFkyQ2pJSG4wZz0%3D&ovuser=72f988bf-86f1-41af-91ab-2d7cd011db47%2Cv-aadhyapak%40microsoft.com"
                                                target="_blank">
                                                Warranty & support
                                            </FLink>
                                        </Text>
                                    </div>
                                    <div className="ms-Grid-col ms-sm6">
                                        <div className="copyright">
                                            <Text>© Microsoft 2021</Text>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className="footer-admin">
                    <div className="container">
                        <div className="top-footer">
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm9">
                                        <Text aria-label="Contacts header">
                                            <h5>
                                                <Trans>Contacts</Trans>
                                            </h5>
                                        </Text>
                                        <ul className="footer_links">
                                            <li className="footer_links_inline">
                                                <Text role="navigation" aria-label={`${StringConstants.SDSG} link`}>
                                                    <Link
                                                        role="link"
                                                        onClick={() => setSelectedTab(StringConstants.SDSG)}
                                                        to="/team-contacts"
                                                        data-testid="sdsg-link">
                                                        { StringConstants.SDSG }
                                                    </Link>
                                                </Text>
                                            </li>

                                            <li className="footer_links_inline">
                                                <Text role="navigation" aria-label={`${StringConstants.CXP} link`}>
                                                    <Link
                                                        role="link"
                                                        onClick={() => setSelectedTab(StringConstants.CXP)}
                                                        to="/team-contacts"
                                                        data-testid="cxp-link">
                                                        {StringConstants.CXP}
                                                    </Link>
                                                </Text>
                                            </li>

                                            <li className="footer_links_inline">
                                                <Text role="navigation" aria-label={`${StringConstants.CSS} link`}>
                                                    <Link
                                                        role="link"
                                                        onClick={() => setSelectedTab(StringConstants.CSS)}
                                                        to="/team-contacts"
                                                        data-testid="css-link">
                                                        {StringConstants.CSS}
                                                    </Link>
                                                </Text>
                                            </li>

                                            <li className="footer_links_inline">
                                                <Text role="navigation" aria-label={`${StringConstants.CREW} link`}>
                                                    <Link
                                                        role="link"
                                                        onClick={() => setSelectedTab(StringConstants.CREW)}
                                                        to="/team-contacts"
                                                        data-testid="crew-link">
                                                        {StringConstants.CREW}
                                                    </Link>
                                                </Text>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="ms-Grid-col ms-sm3">
                                        <div className="links-container">
                                            <div role="navigation" aria-label="Feedback links">
                                                {
                                                    <Link
                                                        role="link"
                                                        className="footer-feedback-btn"
                                                        to="/submit-feedback"
                                                        data-testid="feedback-link">
                                                        <Trans>Feedback</Trans>
                                                    </Link>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-footer">
                        <div className="container">
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm6">
                                        <span className="icon-global"></span>
                                        <Text className="lang">English (United States)</Text>
                                        <Text className="links" role="navigation" aria-label={'Privacy & Cookie'}>
                                            <FLink role="link" href="https://www.microsoft.com/en-us/privacy/data-privacy-notice" target="_blank" rel="noopener noreferrer">
                                                <Trans>Data Protection Notice</Trans>
                                            </FLink>
                                        </Text>
                                        <Text className="links" role="navigation" aria-label="Terms of use">
                                            <FLink
                                                role="link"
                                                href="https://www.microsoft.com/en-us/legal/terms-of-use"
                                                target="_blank">
                                                <Trans>Terms of use</Trans>
                                            </FLink>
                                        </Text>
                                        <Text className="links" role="navigation" aria-label="Terms of use">
                                            <FLink
                                                role="link"
                                                href="https://microsoft.sharepoint.com/sites/surface/SitePages/Warranty-&-Support.aspx?xsdata=MDN8MDF8fGQ5NzY4MTVkZmRhNDQ5MWZhYTEwOTM5YjRjMWVmZjc1fDcyZjk4OGJmODZmMTQxYWY5MWFiMmQ3Y2QwMTFkYjQ3fDF8MHw2Mzc3MjU4OTY2MTY0MDc5Mzh8R29vZHxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaUlpd2lRVTRpT2lJaUxDSlhWQ0k2TVRKOQ%3D%3D&sdata=dFI3RTA0N25LR0F6RkwwNnpoOGEyUk9USWtDblAyZmlyVFkyQ2pJSG4wZz0%3D&ovuser=72f988bf-86f1-41af-91ab-2d7cd011db47%2Cv-aadhyapak%40microsoft.com"
                                                target="_blank">
                                                <Trans>Warranty & support</Trans>
                                            </FLink>
                                        </Text>
                                    </div>
                                    <div className="ms-Grid-col ms-sm6">
                                        <Text className="copyright" role="navigation" aria-label="© Microsoft 2021">
                                            © Microsoft 2021
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Footer;
